import { render } from "./CreateRewardSidebar.vue?vue&type=template&id=0552421d"
import script from "./CreateRewardSidebar.vue?vue&type=script&lang=js"
export * from "./CreateRewardSidebar.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__